import React, { useEffect, useRef } from 'react';
import './ProjectSection.css';

const ourProjects = [
  { src: '/projects/Our Project/Emerald Estate.jpeg', name: 'Emerald Estate' },
  { src: '/projects/Our Project/Gokul.jpg', name: 'Gokul' },
  { src: '/projects/Our Project/kaveri.jpeg', name: 'Kaveri' },
  { src: '/projects/Our Project/Mvf.jpg', name: 'Mvf' },
  { src: '/projects/Our Project/nextgen.jpg', name: 'Nextgen' },
  { src: '/projects/Our Project/Royal Empire.jpeg', name: 'Royal Empire' },
  { src: '/projects/Our Project/Smr Green Woods.jpg', name: 'Smr Green Woods' },
  { src: '/projects/Our Project/Vedic Village.JPG', name: 'Vedic Village' }
];

const ourWorkingProjects = [
  { src: '/projects/Our Working Project/Agf Avenue-2.jpeg', name: 'Agf Avenue-2' },
  { src: '/projects/Our Working Project/Amoda Sari.jpeg', name: 'Amoda Sari' },
  { src: '/projects/Our Working Project/Dholera.jpeg', name: 'Dholera' },
  { src: '/projects/Our Working Project/Mvf Phase -3.jpeg', name: 'Mvf Phase -3' },
  { src: '/projects/Our Working Project/Smr Phase-3.jpeg', name: 'Smr Phase-3' }
];

const ProjectSection = ({
  title = 'Our Projects',
  workingTitle = 'Our Working Projects',
  projects = ourProjects,
  workingProjects = ourWorkingProjects,
}) => {
  const marqueeRefs = useRef([]);

  useEffect(() => {
    // For each marquee track, compute half the scrollWidth (since items duplicated)
    // and set CSS variable --marquee-distance and animationDuration for smooth loop.
    const tracks = document.querySelectorAll('.logo-row.marquee .marquee-track');
    tracks.forEach((track) => {
      // measure total width
      const totalWidth = track.scrollWidth;
      const distance = totalWidth / 2; // we duplicated items, so move by half
      // set CSS var
      track.style.setProperty('--marquee-distance', `${distance}px`);
      // set duration proportional to distance (px) at ~100 px/sec -> adjust as needed
      const speed = 80; // pixels per second
      const duration = Math.max(8, distance / speed); // min duration 8s
      track.style.animationDuration = `${duration}s`;
    });

    // Recompute on resize
    const onResize = () => {
      tracks.forEach((track) => {
        const totalWidth = track.scrollWidth;
        const distance = totalWidth / 2;
        track.style.setProperty('--marquee-distance', `${distance}px`);
        const speed = 80;
        const duration = Math.max(8, distance / speed);
        track.style.animationDuration = `${duration}s`;
      });
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [projects, workingProjects]);
  return (
    <section className="project-section">
      <div className="project-container">
        <h2 className="project-heading">{title}</h2>
        <div className="logo-row marquee">
          <div className="marquee-track" aria-hidden="true">
            {projects.concat(projects).map((project, idx) => (
              <div className="logo-item" key={`p-${idx}`}>
                <img src={project.src} alt={project.name} />
                <div className="project-name">{project.name}</div>
              </div>
            ))}
          </div>
        </div>

        <h2 className="project-heading secondary">{workingTitle}</h2>
        <div className="logo-row marquee">
          <div className="marquee-track" aria-hidden="true">
            {workingProjects.concat(workingProjects).map((project, idx) => (
              <div className="logo-item" key={`w-${idx}`}>
                <img src={project.src} alt={project.name} />
                <div className="project-name">{project.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectSection;


